
    import { Component, Vue } from 'vue-property-decorator';
    import { mapActions, mapMutations, mapState } from 'vuex';
    import UsersDetail from '@/components/Users/UsersDetail.vue';
    import User, { UserRole } from '@/types/User';
    import { LoadUsersPayload, SetUsersDialogs, UsersFilter } from '@/store/users';
    import { DataTableHeaders } from '@/types';

    @Component({
        components: {
            UsersDetail,
        },
        computed: {
            ...mapState('users', ['users', 'roles', 'dialogs', 'loaders']),
        },
        methods: {
            ...mapActions('users', ['loadUsers']),
            ...mapMutations('users', ['setDialogs']),
        },
    })
    export default class Users extends Vue {
        public user = new User();
        public search = '';

        public roles!: UserRole[];
        public loadUsers!: (payload?: LoadUsersPayload) => void;
        public setDialogs!: (dialogs: SetUsersDialogs) => void;

        public filter: UsersFilter = {
            deaktiviert: 'n',
        };

        public get headers(): DataTableHeaders<User> {
            return [
                { text: '', value: 'actions', sortable: false, width: 50 },
                { text: 'Benutzername', value: 'username' },
                { text: 'Vorname', value: 'vorname' },
                { text: 'Nachname', value: 'nachname' },
                { text: 'Rolle', value: 'rollen' },
                { text: 'Deaktiviert', value: 'deaktiviert' },
            ];
        }

        public mounted(): void {
            this.loadUsers({ filter: this.filter });
        }

        public onChangeFilter(): void {
            this.loadUsers({ filter: this.filter });
        }

        public onClickEdit(user: User): void {
            this.user = new User(user);
            this.setDialogs({ edit: true });
        }

        public onClickNew(): void {
            this.user = new User();
            this.setDialogs({ edit: true });
        }
    }
